import * as yup from "yup";
import { validarTelefone } from "../../core/utils/validarTelefone";
import { validarCpf } from "../../core/utils/validarCpf";

export const cadastrarUsuarioSchema =  yup.object().shape({
  email: yup.string().email("Endereço de e-mail inválido").required("O endereço de e-mail é obrigatório"),
  nome: yup.string().required("O nome é obrigatório"),
  telefone: yup.string().required("O telefone é obrigatório").test('telefone', 'Telefone inválido', (value) => validarTelefone(value, false)),
  perfil: yup.string().required("O perfil é obrigatório"),
  cpf: yup.string().test('cpf', 'CPF inválido', (value) => validarCpf(value, false)),
});
  